import { FileOutput } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import ToolPage from "./ToolPage";

export default function CSVToExcel() {
  const { t } = useLanguage();
  const tk = t.tools.csvToExcel;

  const config = {
    title: tk.title,
    description: tk.description,
    action: tk.action,
    hint: tk.dropHint,
    hintSub: tk.dropHintSub,
    endpoint: "/excel/csv-to-excel",
    accept: ".csv",
    multiple: false,
    resultType: "download",
    resultFileName: tk.result,
    color: "#059669",
    Icon: FileOutput,
    toolKey: "csvToExcel",
  };

  return <ToolPage config={config} />;
}
